import { postRequest } from "@utils/axiosInstance";

export function doLogin(login: string, senha: string) {
  return postRequest("login", {
    login,
    senha,
  });
}
